import React from 'react';
import './../../../Styles/Main/ProfilePage/ProfileHeader.scss'

function ProfileHeader({ showPage, updateHistoryPage }) {

   const changingTabs = (e) => {
      showPage(e.id)
      let tabs = Array.from(document.querySelectorAll('.profileHeader__tab'));
      for (let key in tabs) {
         if (e.id === tabs[key].id) {
            e.classList.add('profileHeader__tab-active');
         } else if (e.id !== tabs[key].id && tabs[key].classList.contains('profileHeader__tab-active')) {
            tabs[key].classList.remove('profileHeader__tab-active');
         }
      }
   }


   return (
      <div className="profileHeader__body">
         <div
            id='profileHeader-current'
            className="profileHeader__tab profileHeader__tab-active"
            onClick={e=>changingTabs(e.target)}
         >Current orders</div>
         <div
            id='profileHeader-history'
            className="profileHeader__tab"
            onClick={e=>changingTabs(e.target)}
         >Order`s history</div>
         <div
            id='profileHeader-info'
            className="profileHeader__tab"
            onClick={e=>changingTabs(e.target)}
         >Personal information</div>
      </div>
   );
}
export default ProfileHeader;